<template>
    <div>
        <div class="row">
            <div class="col-xs-12 card-title-row">
                <span class="ms-icon ms-icon-circle ms-icon-inverse ms-icon-xlg color-dark">
                    <i class="fal fa-comments"></i>
                </span>

                <span class="l-default-margin">
                    <span class="headline">
                        {{ $t(`reviews.update.peerSelfNominationTitle`) }}
                    </span>
                    <br />
                    <span class="color-grey">
                        {{ $t(`reviews.update.peerSelfNominationSubtitle`) }}
                    </span>
                </span>
            </div>
        </div>

        <hr />

        <p align="justify">
            {{ $t(`reviews.update.peerSelfNominationHelp`) }}
        </p>

        <l-space :size="1" />

        <div class="row">
            <div class="col-md-12">
                <l-input-typeahead
                    v-if="!peerSelfSelected"
                    style="margin-top: 0"
                    :label="``"
                    :placeholder="$t(`reviews.update.nPeersSearchPlaceholder`)"
                    :data="users"
                    :on-select="typeaheadSelfNominationOnSelect"
                    :on-input-change="typeaheadSelfNominationOnInput"
                />
                <div v-else style="display: flex; align-items: center;">
                    <l-input-text
                        type="text"
                        style="flex-grow: 1"
                        :label="``"
                        :value="peerSelfNomination"
                        disabled
                    />
                    <span
                        class="l-default-margin-s color-primary clickable"
                        tabindex="0"
                        @click="
                            () => {
                                error = null;
                                peerSelfSelected = false;
                            }
                        "
                        @keyup.enter="
                            () => {
                                error = null;
                                peerSelfSelected = false;
                            }
                        "
                    >
                        <i class="fal fa-pencil"></i>
                    </span>
                </div>
            </div>
        </div>

        <div v-if="error">
            <l-space :size="1" />
            <div id="error" class="alert alert-danger">
                <span>{{ error.message }}</span>
            </div>
        </div>

        <div class="pull-right">
            <button
                v-show="!peerSelfNominationSuccess"
                class="btn btn-primary btn-raised"
                :disabled="!peerSelfSelected"
                type="button"
                @click="updatePeersSelfNominate()"
            >
                {{ $t(`reviews.update.btnSelfNominate`) }}
            </button>
        </div>

        <div class="pull-right">
            <button
                v-show="peerSelfNominationSuccess"
                class="btn btn-primary btn-raised"
                type="button"
                @click="
                    reviewCycleUpdate({
                        reviewCycleId: reviewCycle._id,
                        revieweeId: reviewCycle.revieweeUser._id,
                        role: 'peer',
                        view: 'overview',
                        contributorId: user._id,
                        viewAs: 'peer',
                        entrypoint: 'toDo',
                    })
                "
            >
                {{ $t(`reviews.update.btnSelfNominateContinue`) }}
            </button>
        </div>

        <br />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import format from "@/utils/format-typeahead";

import LInputText from "@/components/LInputText";
import LInputTypeahead from "@/components/LInputTypeahead";
import LSpace from "@/components/LSpace";

export default {
    components: {
        LInputText,
        LInputTypeahead,
        LSpace,
    },
    props: {
        reviewCycleId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            reviewCycle: {},

            peerSelfSelected: false,
            peerSelfNomination: "",
            peerSelfNominationSuccess: false,

            error: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            getReviewCycle: "reviews/participants/details",
            usersSearchList: "users/search/list",
        }),

        users() {
            return this.usersSearchList
                .filter(user => user._id !== this.user._id)
                .map(format.users);
        },
    },
    watch: {
        reviewCycleId: {
            immediate: true,
            handler(reviewCycleId) {
                this.reviewCycle = this.getReviewCycle(reviewCycleId);
            },
        },
    },
    methods: {
        typeaheadSelfNominationOnSelect(user) {
            this.peerSelfNomination = user.firstname + " " + user.lastname;
            this.peerSelfSelected = true;

            this.reviewCycle.revieweeUser = user;

            this.$store.dispatch("users/search/reset");
        },
        typeaheadSelfNominationOnInput(query) {
            if (query.length >= 2) {
                this.$store.dispatch("users/search/findByName", { query });
            } else {
                this.$store.dispatch("users/search/reset");
            }
        },
        updatePeersSelfNominate() {
            this.error = null;
            this.peerSelfNominationSuccess = false;

            this.$store
                .dispatch({
                    type: "reviews/participants/selfnominate",
                    payload: {
                        reviewCycle: this.reviewCycle._id,
                        reviewee: this.reviewCycle.revieweeUser._id,
                    },
                })
                .then(() => {
                    this.peerSelfNominationSuccess = true;
                })
                .catch(err => {
                    if (err?.response?.data?.error?.message) {
                        this.error = { message: err.response.data.error.message };
                    }
                });
        },
        reviewCycleUpdate(opts) {
            this.$router.push(
                `/reviews/update/${opts.reviewCycleId}/reviewee/${opts.revieweeId}/${opts.role}/${opts.contributorId}/viewAs/${opts.viewAs}/${opts.view}/${opts.entrypoint}`,
            );
        },
    },
};
</script>
